import type { FaireProductEntity } from "../../entity_types/product";

export const p_t6xa8apzh4: FaireProductEntity = {
  token: "p_t6xa8apzh4",
  type: "product",
  name: "MegaSnax Neon Worms",
  brandToken: "b_7p5vnswqfb",
  brandName: "MEGASNAX",
  imageUrl:
    "https://cdn.faire.com/fastly/69d88d5e697af0a452607e634f5ee45dad5b66222a0b18166dee71873cb52611.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa4563f0c0e1a22cc316dd9c968d9009cf3e1f25a3d5456211e9556796e8cef8.jpeg",
  ],
  priceDollars: 2.31,
  description:
    'MegaSnax Neon Worms are a popular, multi-colored gummy candy known for their vibrant appearance, assorted fruity flavors, and signature soft, chewy texture. \n\nKey Characteristics\n\nFlavor Assortment: These worms feature a variety of assorted fruit flavors. Each worm is typically two-toned, combining complementary flavors such as:\nCherry & Lime\nLemon & Orange\nStrawberry & Grape\nBlue Raspberry & Green Apple\n\nTexture: They are known for being soft, tender, and satisfyingly chewy. Some variations may have a light sugar sanding for an extra textural element.\n\nAppearance: The gummies are long, worm-shaped, and feature extremely bright, "neon" colors that make them visually striking and fun.\n\nMegaSnax also offers a variation with a popular Mexican-inspired twist:\nChamoy Neon Worms: This version features the same multi-colored gummy worms saturated in a blend of tangy chamoy sauce and chili-lime seasoning, offering a complex mix of sweet, sour, salty, and spicy flavors. \n\nMegaSnax gummi worms are a versatile and fun snack suitable for everyday treats, party favors, or candy buffets.',
  tags: [],
  msrpDollars: 4.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:08.058Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
